import { Grid, Box } from '@mui/material';
import UserCard from '../UserCard/UserCard';
import { useUsersContext } from 'context/UsersContext';
import CustomText from 'components/common/CustomText/CustomText';
import { colors } from 'styles/colors';
import { hexWithOpacity } from 'common/utils';
import UsersIconOutline from 'icons/UsersIconOutline';

export default function Users() {
  const { staff, isLoading, isFetching } = useUsersContext();

  if (isLoading) {
    return (
      <Grid container spacing={2}>
        {Array.from({ length: 16 }).map((_, index) => (
          <Grid key={index} size={{ xs: 12, md: 6, lg: 3 }}>
            {/* <UserCardSkeleton /> */}
          </Grid>
        ))}
      </Grid>
    );
  }
  // ✅ Empty state
  if (!staff || staff.length === 0) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="100%"
        textAlign="center"
        gap={2}
        minHeight={'80vh'}
      >
        <Box height={100}>
          <UsersIconOutline
            size={100}
            color={hexWithOpacity(colors.secondary, 0.5)}
          />
        </Box>
        <CustomText text="No users found" fontWeight={600} color={colors.secondary} />
        <CustomText text="Users will appear here once they are added" color={colors.secondary} />
      </Box>
    );
  }

  return (
    <Grid container spacing={2}>
      {staff.map((item) => (
        <Grid key={item.end_user.id} size={{ xs: 12, md: 6, lg: 3 }}>
          <UserCard item={item} />
        </Grid>
      ))}
    </Grid>
  );
}